import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { useCallback } from "react";
import { PostUserUploadFilesDataTypes } from "../../../../Schema/postUserUploadFiles.types";

export type UploadedFilesInitialStateTypes = {
  files: PostUserUploadFilesDataTypes["user_file"][];
};

const initialState = {
  files: [],
} as UploadedFilesInitialStateTypes;

export const uploadedFilesSlice = createSlice({
  initialState,
  reducers: {
    addFile: (state, action: PayloadAction<PostUserUploadFilesDataTypes["user_file"]>) => {
      state.files.push(action.payload);
    },
    removeAudioFile: (state) => {
      state.files = state.files.filter((file) => !file.isAudio);
    },
    removeFile: (state, action: PayloadAction<PostUserUploadFilesDataTypes["user_file"]>) => {
      const index = state.files.findIndex((file) => file.id === action.payload.id);
      if (index !== -1) {
        state.files.splice(index, 1);
      }
    },
    resetFiles: (state) => {
      state.files = [];
    },
  },
  name: "uploadedFilesSlice",
});

export const { addFile, removeFile, resetFiles, removeAudioFile } =
  uploadedFilesSlice.actions || {};
export default uploadedFilesSlice.reducer;

export const useUploadedFiles = () => {
  const dispatch = useAppDispatch();
  const { files } = useAppSelector((state) => state.uploadedFiles);

  const dispatchRemoveFile = useCallback(
    (data: PostUserUploadFilesDataTypes["user_file"]) => {
      dispatch(removeFile(data));
    },
    [dispatch],
  );
  const dispatchResetFile = useCallback(() => {
    dispatch(resetFiles());
  }, [dispatch]);

  const dispatchRemoveAudioFile = useCallback(() => {
    dispatch(removeAudioFile());
  }, [dispatch]);

  return {
    dispatchRemoveFile,
    files,
    dispatchResetFile,
    dispatchRemoveAudioFile,
  };
};
